import React, {useEffect, useState} from 'react';
import {inject, observer} from 'mobx-react';
import {useNavigate, useParams} from 'react-router-dom';
import {toast} from 'react-toastify';
import AiSettingsUI from '../view/AiSettingsUI';
import {LLM_PROVIDER_OPTIONS} from '../../../../forms/OrgDataForm/options';
import {
  ORGANIZATION_SUBSCRIPTION_ACTIVE,
  OrganizationSettings,
} from '../../../../data/models/Oganization/Organization';
import {toastConfig} from '../../../../uiToolkit/Toast/toastConfig';
import NavigationStore from '../../../../navigation/store/NavigationStore';
import DashboardStore from '../../store/DashboardStore';
import SettingsStore from '../../store/SettingsStore';
import {settingsText} from '../../settingsText';

interface Props {
  settingsStore?: SettingsStore;
  dashboardStore?: DashboardStore;
  navigationStore?: NavigationStore;
}

const AiSettingsContainer = inject(
  'settingsStore',
  'dashboardStore',
  'navigationStore',
)(
  observer(({settingsStore, dashboardStore, navigationStore}: Props) => {
    const [organization, setOrganization] = useState<OrganizationSettings>();
    const [llmProvider, setLlmProvider] = useState(LLM_PROVIDER_OPTIONS[0].key);
    const {organizationId} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
      if (!organizationId) return;
      settingsStore!.getOrganizationDetails(organizationId).then(loaded => {
        setOrganization(loaded);
        if (loaded?.llmProvider) {
          setLlmProvider(loaded.llmProvider);
        }
      });
      if (
        navigationStore!.subscriptionStatus === ORGANIZATION_SUBSCRIPTION_ACTIVE
      ) {
        dashboardStore!.fetchDashboardDetails(organizationId);
      }
    }, []);

    const onSave = async () => {
      if (!organization) return;
      const success = await settingsStore!.editOrganization({
        ...organization,
        llmProvider,
      });
      if (success) {
        toast.success(settingsText.detailsUpdated, toastConfig);
      }
    };

    const plan = navigationStore!.organizationSubscription?.type;

    return (
      <AiSettingsUI
        llmProvider={llmProvider}
        setLlmProvider={setLlmProvider}
        onSave={onSave}
        isLoading={settingsStore!.isLoading}
        canSave={!!organization && llmProvider !== organization.llmProvider}
        dashboard={dashboardStore!.dashboardData}
        onBuyAddons={() => navigate(`/${organizationId}/marketplace`)}
        disabled={plan === 0 || plan === undefined}
      />
    );
  }),
);

export default AiSettingsContainer;
